export default __webpack_public_path__ + "static/media/561.19038e44.gif";